export let finances = [];

//subsidys
finances.push({
  id: 0,
  name: "Slimme technieken",
  amount: 1000,
  type: "subsidy",
  active: false,
  affects: ["upgrades", [3, 4, 5, 6]],
  icon: "icon--smart"
});
finances.push({
  id: 1,
  name: "Kleine centrales",
  amount: 1000,
  type: "subsidy",
  active: false,
  affects: ["powerPlants", [1, 2, 3, 4, 5, 6]],
  icon: "icon--decentral"
});
finances.push({
  id: 2,
  name: "Windparken op zee",
  amount: 1000,
  type: "subsidy",
  active: false,
  affects: ["powerPlants", [7, 8, 9]],
  icon: "icon--windfarm"
});
finances.push({
  id: 3,
  name: "Zonne-energiecentrales",
  amount: 800,
  type: "subsidy",
  active: false,
  affects: ["powerPlants", [4, 5, 10, 11, 12]],
  icon: "icon--solar"
});

//Taxes
finances.push({
  id: 4,
  name: "Elektriciteit uit kolen (per MWU) 1",
  amount: 20,
  type: "tax",
  active: false,
  affects: ["powerPlantsBuyMwu", [13, 14]],
  icon: "icon--plant"
});
finances.push({
  id: 5,
  name: "Elektriciteit uit kolen (per MWU) 2",
  amount: 50,
  type: "tax",
  active: false,
  affects: ["powerPlantsBuyMwu", [13, 14]],
  icon: "icon--plant"
});
finances.push({
  id: 6,
  name: "Elektriciteit uit kolen en gas (per MWU) 1",
  amount: 10,
  type: "tax",
  active: false,
  affects: ["powerPlantsBuyMwu", [13, 14, 15, 16]],
  icon: "icon--gas"
});
finances.push({
  id: 7,
  name: "Elektriciteit uit kolen en gas (per MWU) 2",
  amount: 40,
  type: "tax",
  active: false,
  affects: ["powerPlantsBuyMwu", [13, 14, 15, 16]],
  icon: "icon--gas"
});
finances.push({
  id: 8,
  name: "Vergunning voor gas- en kolencentrales",
  amount: 1000,
  type: "tax",
  active: false,
  affects: ["powerPlants", [13, 14, 15, 16]],
  icon: "icon--plant"
});



// WEBPACK FOOTER //
// ./src/actions/financesArray.js